export default "__VITE_ASSET__a3ff8882__"